var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#D2D6DD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.531 11.434C2.485 11.48.92 15.899.92 15.899c-.159.383.267.85.68.68 0 0 4.442-1.542 4.489-1.589m-4.853.025l1.251 1.251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.288 3.245l-2.011-2.011a1.093 1.093 0 00-1.546 0l-10.2 10.2 3.557 3.556 10.2-10.2a1.093 1.093 0 000-1.545zM4.685 13.587l8.325-8.325"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSIjRDJENkREIj4KICAgICAgICA8cGF0aCBkPSJNMi41MzEgMTEuNDM0QzIuNDg1IDExLjQ4LjkyIDE1Ljg5OS45MiAxNS44OTljLS4xNTkuMzgzLjI2Ny44NS42OC42OCAwIDAgNC40NDItMS41NDIgNC40ODktMS41ODlNMS4yMzYgMTUuMDE1bDEuMjUxIDEuMjUxIi8+CiAgICAgICAgPHBhdGggZD0iTTE2LjI4OCAzLjI0NWwtMi4wMTEtMi4wMTFhMS4wOTMgMS4wOTMgMCAwIDAtMS41NDYgMGwtMTAuMiAxMC4yIDMuNTU3IDMuNTU2IDEwLjItMTAuMmExLjA5MyAxLjA5MyAwIDAgMCAwLTEuNTQ1ek00LjY4NSAxMy41ODdsOC4zMjUtOC4zMjUiLz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgEditGrey as ReactComponent };